export const actionType = {
    HEALTH_RIGHT: 'חיפוש בכל הבריאות',
    CLINIC: 'חיפוש מרפאות',
    DOCTOR: 'חיפוש רופאים',
    KEYWORD: 'חיפוש על פי מילת מפתח'
}

export const categoryType = {
    HEALTH_RIGHT: 'כל הבריאות',
    USER_AREA: 'מה מגיע לי',
    POLICY: 'פוליסות'
}
